module.exports = __webpack_public_path__ + "static/media/notify.bfa03391.svg";